





import { Component, Prop, Vue } from 'vue-property-decorator';
import { VNode } from 'vue';
import { generateHash } from './helper/hash';
@Component
export default class Tab extends Vue {
  @Prop(String) name!: string;
  index = 0
  isActive: boolean = false;

  public setIsActive(isActive: boolean) {
    this.isActive = isActive;
  }

  get id():number{
    return generateHash(this.name+this.index);
  }

  get parentId():string{
    return `tab#${this.id}`;
  }

  public getTabIndex():string{
    return this.isActive ? '0' : '-1';
  }
  
  public setIndex(index:number){
    this.index = index;
  }

}
